import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { BreadcrumbService } from 'src/app/app.breadcrumb.service';
import { CicloVidaLicenca, CicloVidaLicencaItem } from 'src/app/models/ciclo-vida-licenca';
import { HabilEmpresarialProduto } from 'src/app/models/he-produto';
import { RegistroProduto, softwares } from 'src/app/models/registro-produto';
import { AbstractService } from 'src/app/services/abstract.service';
import { CicloVidaService } from 'src/app/services/ciclo-vida.service';
import { ClassificacaoService } from 'src/app/services/classificacao.service';
import { HabilEmpresarialProdutoService } from 'src/app/services/he-produto.service';
import { ProdutoService } from 'src/app/services/produto.service';
import { GenericCadastro } from 'src/app/utilities/generic-cadastro';
import { clone } from 'src/app/utilities/util/clone-utils';
import { FormValidation } from 'src/app/utilities/util/form-validation';

@Component({
  selector: 'habil-cadastro-ciclo-vida',
  templateUrl: './cadastro-ciclo-vida.component.html',
  styleUrls: ['./cadastro-ciclo-vida.component.scss']
})
export class CadastroCicloVidaComponent extends GenericCadastro<CicloVidaLicenca, CicloVidaService> implements OnInit {

  softwares = softwares;
  modulos: any[] = [];
  loadingModules = true;
  modules: any[] = [];
  modulesHe: HabilEmpresarialProduto[] = [];
  modulesH10: RegistroProduto[] = [];

  newObject(): CicloVidaLicenca {
    let obj = new CicloVidaLicenca();
    return obj;
  }

  onChangeSoftware() {
    if (this.obj.software == 'HABIL_10') {
      this.modules = [...this.modulesH10];
      return;
    }
    if (this.obj.software == 'HABIL_EMPRESARIAL') {
      this.modules = [...this.modulesHe];
      return;
    }
    this.modules = [];
  }

  doValidate(): boolean {
    this.corrigeAtributos();
    let validation: FormValidation = new FormValidation();
    validation.toValidate = [
      {
        condition: this.obj.nome != undefined && this.obj.nome.length > 0,
        message: "O nome é obrigatório!",
      }
    ];
    const selecionados = { [this.obj.idModuloPrimeiro]: true };
    for (const m of this.obj.itens) {
      if (selecionados[m.idModuloNovo]) {
        this.messageService.add({
          severity: 'warn',
          detail: "Não é permitido informar duas vezes o mesmo módulo!"
        })
        return false;
      }
      selecionados[m.idModuloNovo] = true;
    }
    if (!validation.isValid()) {
      validation.message().forEach((m) => {
        this.messageService.add({
          severity: "warn",
          summary: "Atenção",
          detail: m,
        });
      });
    }
    return validation.isValid();
  }

  constructor(
    public service: CicloVidaService,
    public messageService: MessageService,
    public dialogService: DialogService,
    public route: ActivatedRoute,
    public router: Router,
    public confirmationService: ConfirmationService,
    public titleService: Title,
    public breadcrumbService: BreadcrumbService,
    public classificacaoService: ClassificacaoService,
    public h10Service: ProdutoService,
    public heService: HabilEmpresarialProdutoService
  ) {
    super();
    this.breadcrumbService.setItems([
      { label: 'Ciclos de vida', routerLink: '/adm/ciclos-vida' },
      { label: 'Cadastro' }
    ]);
  }

  async ngOnInit() {
    if (this._isDialog) {
      this._loading = true;
      if (this._externalObj != null && this._externalObj != undefined) {
        this.obj = clone(this._externalObj);
        this.id = this.obj.id;
        this.idCampos = (this.id == undefined ? "0" : this.id.toString());
        this._loading = false;
      } else {
        this.obj = this.newObject();
        this.idCampos = (this.id == undefined ? "0" : this.id.toString());
        this.loadAuxObjects();
        this._loading = false;
        this.onChangeSoftware();
        this.loadingModules = false;
      }
    } else {
      this.titleService.setTitle('Ciclo de vida - ' + AbstractService.app);
      super.ngOnInit();
    }

    const he = await this.heService.findAll(0, 9999, '').toPromise();
    if (he) this.modulesHe = [...he] as any[];
    const h10 = await this.h10Service.findAll(0, 9999, '').toPromise();
    if (h10) this.modulesH10 = [...h10] as any[];
    this.loadingModules = false;
    this.onChangeSoftware();
  }

  adicionarItem() {
    const item = new CicloVidaLicencaItem();
    let itemComMaiorIdInterno = this.obj.itens?.length ? this.obj.itens?.reduce((maior, atual) => {
      return atual.idInterno > maior.idInterno ? atual : maior;
    }) : undefined;
    item.idInterno = (itemComMaiorIdInterno?.idInterno || 0) + 1;
    this.obj.itens.push(item);
    this.obj.itens = [...this.obj.itens];
  }

  afterLoadObj(): void {
    this.onChangeSoftware();
  }

  apagarItem(i: CicloVidaLicencaItem) {
    this.obj.itens = [...this.obj.itens?.filter((li) => li.idInterno != i.idInterno)];
    let idInterno = 0;
    for (const item of this.obj.itens) {
      item.idInterno = idInterno +1;
      idInterno++;
    }
  }


  doBeforeSave() { }

}
